import { down, up } from 'styled-breakpoints';
import styled from 'styled-components';

import bg from 'assets/images/cover-new.jpeg';

export const FullScreenCover = styled.div`
    background-image: url(${bg});
    background-size: cover;
    background-position: center center;
    min-height: 100%;
    overflow: hidden;

    padding: 30px;

    width: 100%;
    height: auto;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    & > div {
        width: 100%;

        ${up('sm')} {
            width: 540px;
        }
        ${up('md')} {
            width: 720px;
        }
        ${up('lg')} {
            width: 960px;
        }
        ${up('xl')} {
            width: 1140px;
        }
        ${up('xxl')} {
            width: 1320px;
        }
        ${down('lg', 'landscape')} {
            width: 100%;
        }
    }

    ${down('lg')} {
        padding-left: calc(16px + env(safe-area-inset-left));
        padding-right: calc(16px + env(safe-area-inset-right));
    }
`;

export const HeadingContent = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;

    margin: 0 auto;

    border-bottom: 1px solid rgba(255, 255, 255, 0.7);
    padding-bottom: 30px;

    & > .ia-logo svg {
        display: flex;
        margin: auto;
        width: 120px;
        ${down('lg', 'landscape')} {
            width: 85px;
        }
        ${down('lg', 'portrait')} {
            width: 120px;
        }
        ${down('md', 'portrait')} {
            width: 85px;
        }
    }

    & > a svg {
        ${down('lg', 'landscape')} {
            width: 200px;
        }
        ${down('md')} {
            width: 200px;

            g {
                path:first-child {
                    display: none;
                }
            }
        }
    }

    ${down('lg', 'landscape')} {
        margin: -15px auto;
        padding-bottom: 0px;
    }
    ${down('md')} {
        margin: -15px auto;
        padding-bottom: 0px;
    }
`;

const PADDING_SPINNERS = '16px';

export const WelcomeContent = styled.div`
    margin: 40px auto;
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    color: ${({ theme }) => theme.palette.common.white};

    position: relative;

    ${down('lg', 'landscape')} {
        margin: 0px auto;
    }

    h1 {
        font-weight: 500;
        font-size: 73px;
        line-height: 93px;

        @media screen and (max-width: 1600px) {
            font-size: 56px;
            line-height: 76px;
        }

        ${down('xxl')} {
            font-size: 64px;
        }
        ${down('xl')} {
            font-size: 44px;
            line-height: normal;
        }
        ${down('lg')} {
            font-size: 32px;
        }
        ${down('sm')} {
            font-size: 24px;
        }
    }
    h2 {
        font-weight: 300;
        font-size: 40px;
        text-transform: uppercase;
        margin-bottom: 50px;

        ${down('xxl')} {
            font-size: 36px;
        }
        ${down('xl')} {
            font-size: 28px;
            line-height: normal;
            margin-bottom: 20px;
        }
        ${down('lg')} {
            font-size: 24px;
        }
        ${down('sm')} {
            font-size: 18px;
        }
    }

    .spin-wrapper {
        position: absolute;
        right: 3%;
        top: -200px;

        width: 300px;
        height: 300px;

        :hover {
            .spin-quarter:nth-of-type(1) {
                border-top-color: #fff;
            }
        }
        transform: scale(0.9);

        @media screen and (max-width: 1600px) {
            transform: scale(0.6);
        }

        ${down('xxl')} {
            top: -300px;
            transform: scale(0.7);
        }
        ${down('xl', 'landscape')} {
            top: -300px;
            transform: scale(0.7);
        }
        ${down('lg', 'landscape')} {
            top: -200px;
            transform: scale(0.4);
        }
        ${down('md')} {
            top: -300px;
            transform: scale(0.5);
        }
        ${down('md', 'landscape')} {
            top: -200px;
            transform: scale(0.4);
        }
        ${down('sm')} {
            top: -300px;
            transform: scale(0.5);
            margin: 0 auto;
            left: 0;
        }
    }

    .text-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 300px;
        height: 300px;
        background-color: #fff;
        border-radius: 50%;

        z-index: 11;
        transition: 400ms;

        :hover {
            a {
                color: #fff;
                transition: 400ms;
            }
        }
    }
    .spin-quarter:nth-of-type(1) {
        position: absolute;
        box-sizing: border-box;
        top: ${PADDING_SPINNERS};
        left: ${PADDING_SPINNERS};
        right: 0;
        bottom: 0;
        border: 1px solid rgba(0, 0, 0, 0.3);
        border-top: 2px solid #000;
        border-radius: 50%;
        z-index: 12;
        pointer-events: none;

        width: calc(300px - ${PADDING_SPINNERS}*2);
        height: calc(300px - ${PADDING_SPINNERS}*2);
    }
    .spin-quarter:nth-of-type(2) {
        position: absolute;
        box-sizing: border-box;
        top: -${PADDING_SPINNERS};
        left: -${PADDING_SPINNERS};
        right: 0;
        bottom: 0;
        border: 1px solid rgba(0, 0, 0, 0.3);
        border-right: 2px solid #8b8a8a;
        border-radius: 50%;

        width: calc(300px + ${PADDING_SPINNERS} * 2);
        height: calc(300px + ${PADDING_SPINNERS} * 2);
    }

    .spin-quarter:nth-of-type(3) {
        position: absolute;
        box-sizing: border-box;
        top: calc((-${PADDING_SPINNERS}*5) / 2);
        left: calc((-${PADDING_SPINNERS}*5) / 2);
        right: 0;
        bottom: 0;
        border: 1px solid rgba(0, 0, 0, 0.3);
        border-top: 2px solid #8b8a8a;
        border-radius: 50%;

        width: calc(300px + ${PADDING_SPINNERS} * 5);
        height: calc(300px + ${PADDING_SPINNERS} * 5);
    }
    .spin-quarter:nth-of-type(4) {
        position: absolute;
        box-sizing: border-box;
        top: calc((-${PADDING_SPINNERS}*7) / 2);
        left: calc((-${PADDING_SPINNERS}*7) / 2);
        right: 0;
        bottom: 0;
        border: 1px solid rgba(0, 0, 0, 0.3);
        border-left: 2px solid #8b8a8a;
        border-radius: 50%;

        width: calc(300px + ${PADDING_SPINNERS} * 7);
        height: calc(300px + ${PADDING_SPINNERS} * 7);
    }

    a {
        position: absolute;
        top: 15px;
        left: 15px;
        z-index: 4;

        height: calc(100% - 30px);
        width: calc(100% - 30px);

        display: flex;
        align-items: center;
        justify-content: center;

        z-index: 333;
        text-transform: uppercase;
        font-weight: 600;
        font-size: 25px;
        color: #000501;

        border-radius: 100%;
    }
`;
